import { render, staticRenderFns } from "./DayReportCloseDetail.vue?vue&type=template&id=c2809366"
import script from "./DayReportCloseDetail.vue?vue&type=script&lang=js"
export * from "./DayReportCloseDetail.vue?vue&type=script&lang=js"
import style0 from "./DayReportCloseDetail.vue?vue&type=style&index=0&id=c2809366&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports